export const PredictionState = {
  GENERATED: 'GENERATED',
  ERROR: 'ERROR',
  GENERATING: 'GENERATING',
  INITIAL: 'INITIAL',
  PARTIALLY_GENERATED: 'PARTIALLY_GENERATED'
};
